import React, { useState, useEffect } from 'react'
import Loader from '../../component/loader/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { useFormik } from 'formik';
import SaveButton from '../../component/buttons/SaveButton';
import DataTable from '../../component/data_table/DataTable';
import { toast, ToastContainer } from 'react-toastify';
import { VoucherListRes, VoucherListTodo } from '../../redux/Slices/discount-voucher-list/VoucherList';
import { VoucherPDFRes, VoucherPDFTodo } from '../../redux/Slices/discount-voucher-list/VoucherListPdf';
// import DeleteInvoice from './DeleteInvoice';


export default function DistVoucherList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pageLimit, setPageLimit] = useState(10)
    const [pageSize, setPageSize] = useState(0)
    const [deleteModal, setDeleteModal] = useState(false)
    const [invoiceData, setInvoiceData] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)

    const voucher_list = useSelector(state => state?.VoucherList?.data?.data)
    // const TotalCount = useSelector(state => state?.ChallanList?.data?.list_size)
    // console.log(voucher_list, 'voucher_list')

    const initialValues = {
        fromDate: '',
        toDate: ''
    }
    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,

        onSubmit: (values, action) => {
            setFilterLoad(true)
            dispatch(VoucherListTodo({  "fromDate": values.fromDate, "toDate": values.toDate })).then(() => filter_res())
        }
    })
    // console.log(values, 'vb')



    const handleReset = () => {
        setLoading(true)
        setFieldValue('fromDate', ""); // Reset fromDate
        setFieldValue('toDate', "");   // Reset search
        dispatch(VoucherListTodo()).then(() => filter_res())
    };



    const filter_res = () => {
        if (VoucherListRes && VoucherListRes.success) {
            setFilterLoad(false)
        } else {
            setFilterLoad(false)
        }
    }

    const pdfGenrate = (data) => {
        setFilterLoad(true)
        dispatch(VoucherPDFTodo(data)).then(() => pdf_res())
    }

    const pdf_res = () => {
        if (VoucherPDFRes && VoucherPDFRes.status) {
            setFilterLoad(false)
            toast.success(VoucherPDFRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                window.open(VoucherPDFRes?.return_file, '_blank');
            }, 1500);


        } else {
            setFilterLoad(false)
            toast.error(VoucherPDFRes?.message, { position: "bottom-right" });
        }
    }

    setTimeout(() => {
        setLoading(false)
      }, 1500);

    // useEffect(() => {
    //     // setLoading(true)
    //     // dispatch(VoucherListTodo()).then(() => ListFun())
    // }, [bool])

    // const ListFun = () => {
    //     if (VoucherListRes && VoucherListRes.success) {

    //         setLoading(false)
    //     } else {
    //         setLoading(false)
    //     }
    // }

    const columnDefs = [
        {
            headerName: 'S.NO',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            wrapText: true,
            autoHeight: true,
            maxWidth: 70
        },
       
        {
            headerName: 'ACCOUNT',
            field: 'vaccount_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            wrapText: true,
            autoHeight: true,
        },
        {
            headerName: 'VOUCHER CODE',
            field: 'vexp_voucher_code',
            cellRenderer: params => <span onClick={() => pdfGenrate(params?.data?.vexp_voucher_code)} style={{ fontSize: '16px', fontWeight: "600", color: 'red', cursor: 'pointer' }}>{params?.data?.vexp_voucher_code}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 180,
            wrapText: true,
            autoHeight: true,
        },

        {
            headerName: 'AMOUNT',
            field: 'mamount',
            filter: 'agTextColumnFilter',
              suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 120,
            wrapText: true,
            autoHeight: true,
        },
        {
            headerName: 'CREATED BY',
            field: 'vcreated_by',
            // cellRenderer: params => <span>{params?.data?.mrate + ' ' + params?.data?.vunit_short_name}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 130,
            wrapText: true,
            autoHeight: true,
        },
        {
            headerName: 'VOUCHER NO',
            field: 'vintr_voucher_no',
            // cellRenderer: params => <span>{params?.data?.mrate + ' ' + params?.data?.vunit_short_name}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 130,
            wrapText: true,
            autoHeight: true,
        },
        {
            headerName: 'DATE',
            field: 'ddate',
            cellRenderer: params => <span>{new Date(params?.data?.ddate).toLocaleDateString('en-GB')}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 140,
            wrapText: true,
            autoHeight: true,
        },
        {
            headerName: 'REMARK',
            field: 'vremark',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // maxWidth: 130
            wrapText: true,
            autoHeight: true,
        },
      
    ]

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">

                        <div className='layout_head'>
                            <h5>Discount Voucher List</h5>
                        </div>
                        {loading  ?
                            <div className='mt-5 pt-5'>
                                <Loader />
                            </div>
                            :
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                       
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>From Date</label>
                                            <Flatpickr
                                                className='form_input form-control'
                                                name='fromDate'
                                                // value={values?.fromDate || new Date().toISOString()}
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'm-d-Y', // Customize date format as needed
                                                    minDate: '', // Before dates disabled
                                                    maxDate: '', // After dates disabled
                                                    disable: [], // Disable particular date ranges
                                                    mode: "single", //multiple-single-range
                                                    defaultDate: [], // Use today's date as default if none selected
                                                    conjunction: "", // Multiple dates separation
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue('fromDate', moment(e[0]).format("DD/MM/YYYY"))
                                                }}
                                                onBlur={handleBlur}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>To Date</label>

                                            <Flatpickr
                                                className='form_input form-control'
                                                name='toDate'
                                                // value={values?.toDate || new Date().toISOString()}
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'm-d-Y', // Customize date format as needed
                                                    minDate: '', // Before dates disabled
                                                    maxDate: '', // After dates disabled
                                                    disable: [], // Disable particular date ranges
                                                    mode: "single", //multiple-single-range
                                                    defaultDate: [], // Use today's date as default if none selected
                                                    conjunction: "", // Multiple dates separation
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue('toDate', moment(e[0]).format("DD/MM/YYYY"))
                                                }}
                                                onBlur={handleBlur}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <div className='d-flex align-items-center mt-4 mb-1'>
                                                <SaveButton name={'FILTER'} />
                                                <button className='ms-1 refresh_btn' onClick={handleReset} ><IoRefreshOutline style={{ color: 'white' }} size={25} /></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                {filterLoad ?
                                    <div className='d-flex juistify-content-center mt-5 '>
                                        <Loader />
                                    </div> :
                                    voucher_list?.length ?
                                        <>

                                            <div className="mt-1">
                                                <DataTable
                                                    rowData={voucher_list}
                                                    columnDefs={columnDefs}
                                                    height={'70vh'}
                                                />
                                            </div>
                                        </> :
                                        <div className='empty_section text-center'>
                                            <span>DATA NOT FOUND</span>
                                        </div>}
                            </div>

                        }
                    </div>
                </div>
            </div>
            <ToastContainer/>
            {/* <DeleteInvoice deleteModal={deleteModal} setDeleteModal={setDeleteModal} invoiceData={invoiceData} bool={bool} setBool={setBool} /> */}
        </>
    )
}
